import { replaceHistory } from 'browser-history'
import { COHORT_QUERY_PARAM } from 'root-constants'

export const replaceCohortInUrl = (cohort: string): void => {
  const URLParams = new URLSearchParams(document.location.search)

  if (URLParams.get(COHORT_QUERY_PARAM) === cohort) return

  URLParams.set(COHORT_QUERY_PARAM, cohort)

  replaceHistory({
    pathname: document.location.pathname,
    search: URLParams.toString(),
  })
}
